export default __webpack_public_path__ + "static/media/medial_b.6a9e9ed0.jpg";